export const ROUTES = {
  LOGOUT: '/logout',
  HOME: '/',
  DASHBOARD: '/dashboard',

  // CAMPAIGNS
  CAMPAIGNS: '/campaigns',
  CAMPAIGNS_RECURRENT: '/campaigns-recurrent',
  SINGLE_CAMPAIGN_GLOBAL: '/campaign/:campaignId/*',
  SINGLE_CAMPAIGN_RECURRENT_GLOBAL: '/campaign-recurrent/:campaignId/*',
  SINGLE_CAMPAIGN_GENERAL: '/campaign/:campaignId/general/:id',
  SINGLE_CAMPAIGN_CONTENT: '/campaign/:campaignId/content/:influencerId',
  SINGLE_CAMPAIGN_DATES: '/campaign/:campaignId/dates/:influencerId',
  SINGLE_CAMPAIGN_METRICS_INFLUENCERS:
    '/campaign/:campaignId/metrics/influencers',
  SINGLE_CAMPAIGN_METRICS_REPORT: '/campaign/:campaignId/metrics/report',
  SINGLE_CAMPAIGN_INVOICES: '/campaign/:campaignId/invoices/:id',
  SINGLE_CAMPAIGN_INVOICES_INFLUENCERS:
    '/campaign/:campaignId/invoices/influencers',
  SINGLE_CAMPAIGN_SETTINGS_INFLUENCER:
    '/campaign/:campaignId/settings-influencer/:influencerId',
  SINGLE_CAMPAIGN_RECURRENT_SETTINGS_INFLUENCER:
    '/campaign-recurrent/:campaignId/settings-influencer/:influencerId',
  SINGLE_CAMPAIGN_SETTINGS: '/campaign/:campaignId/settings',
  SINGLE_CAMPAIGN_RECURRENT_SETTINGS:
    '/campaign-recurrent/:campaignId/settings',
  SINGLE_CAMPAIGN_RESOURCES: '/campaign/:campaignId/resources',
  SINGLE_CAMPAIGN_RESOURCES_RECURRENT:
    '/campaign-recurrent/:campaignId/resources',

  // USERS
  INFLUENTIA_USERS: '/users',
  SINGLE_INFLUENTIA_USER: '/user/:id',

  // INFLUENCERS
  INFLUENCERS: '/influencers',
  SINGLE_INFLUENCER: '/influencer/:id/profile',
  SINGLE_INFLUENCER_CAMPAIGNS: '/influencer/:id/campaigns',
  SINGLE_INFLUENCER_PROPOSALS: '/influencer/:id/proposals',

  // BRANDS
  BRANDS: '/brands',
  SINGLE_BRAND: '/brand/:id/profile',
  SINGLE_BRAND_CAMPAIGNS: '/brand/:id/campaigns',
  SINGLE_BRAND_PROPOSALS: '/brand/:id/proposals',
  SINGLE_BRAND_MEMBERS: '/brand/:id/members',

  // PROSPECTS
  PROSPECTS: '/prospects',
  SINGLE_PROSPECT: '/prospect/:id/profile',
  SINGLE_PROSPECT_MEMBERS: '/prospect/:id/members',
  SINGLE_PROSPECT_CAMPAIGNS: '/prospect/:id/campaigns',

  // INVOICES
  INVOICES: '/invoices',

  // PROPOSALS
  PROPOSALS: '/proposals',
  SINGLE_PROPOSAL_GLOBAL: '/proposal/:proposalId/*',
  SINGLE_PROPOSAL: '/proposal/:proposalId',
  SINGLE_PROPOSAL_GENERAL: '/proposal/:proposalId/general',
  SINGLE_PROPOSAL_INFLUENCER_SETTINGS:
    '/proposal/:proposalId/influencers/:influencerId',
  SINGLE_PROPOSAL_CAMPAIGN_SETTINGS: '/proposal/:proposalId/campaign',

  // CONTROL
  CONTROL_PIECES: '/control/pieces',

  // CALENDAR
  CALENDAR: '/calendar',

  // PROFILE
  PROFILE: '/profile/my-account',
  PROFILE_NOTIFICATIONS: '/profile/notifications',
  PROFILE_ORG_AND_ACCESS: '/profile/organization-and-access',

  CONFIRM_CONTENT: '/confirm-content',
};

type ReplaceIdsProps = {
  params: { [key: string]: string }[];
  url: string;
};

export const replaceIds = ({ params, url }: ReplaceIdsProps) => {
  let newUrl = url;
  // eslint-disable-next-line no-restricted-syntax
  for (const p of params) {
    newUrl = newUrl.replace(`:${Object.keys(p)[0]}`, p[Object.keys(p)[0]]);
  }
  return newUrl.replace('/*', '');
};
